/**
 * The Morse alphabet and the order it is taught in (docs/MORSE.md §2).
 *
 * A code is written with `.` and `-` — the stored and computed spelling. The
 * screen draws them as `·` and `−`; that is presentation and lives in the client.
 */
export const MORSE_CODE = {
    A: '.-',
    B: '-...',
    C: '-.-.',
    D: '-..',
    E: '.',
    F: '..-.',
    G: '--.',
    H: '....',
    I: '..',
    J: '.---',
    K: '-.-',
    L: '.-..',
    M: '--',
    N: '-.',
    O: '---',
    P: '.--.',
    Q: '--.-',
    R: '.-.',
    S: '...',
    T: '-',
    U: '..-',
    V: '...-',
    W: '.--',
    X: '-..-',
    Y: '-.--',
    Z: '--..',
};
/**
 * The lessons, simplest patterns first (household choice, 2026-10-13): every
 * one-element letter, then two, then three, then four. Within a length the
 * letters are paired so that an early lesson unlocks real Dutch words — E T,
 * then A N gives EEN, AAN, NET, TANTE.
 *
 * Each lesson adds two letters, which is the Koch method's one real lesson
 * kept: a small step, learned to the point of recognition before the next.
 */
export const MORSE_LESSONS = [
    ['E', 'T'],
    ['A', 'N'],
    ['I', 'M'],
    ['S', 'O'],
    ['R', 'K'],
    ['U', 'D'],
    ['W', 'G'],
    ['H', 'B'],
    ['L', 'F'],
    ['P', 'V'],
    ['C', 'J'],
    ['Y', 'Z'],
    ['Q', 'X'],
];
/** Every taught letter, in teaching order. */
export const MORSE_LETTERS = MORSE_LESSONS.flat();
export function morseFor(letter) {
    const code = MORSE_CODE[letter.toUpperCase()];
    if (!code)
        throw new Error(`no morse for ${letter}`);
    return code;
}
/** Which lesson (0-based) teaches this letter. */
export function lessonOf(letter) {
    return MORSE_LESSONS.findIndex((l) => l.includes(letter.toUpperCase()));
}
//# sourceMappingURL=code.js.map